module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运维人员"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入运维人员"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话号码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入电话号码"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone", $$v)
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属公司"
    },
    model: {
      value: (_vm.filters.operationcompanyId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "operationcompanyId", $$v)
      },
      expression: "filters.operationcompanyId"
    }
  }, _vm._l((_vm.operationcompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "系统用户名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入系统用户名称"
    },
    model: {
      value: (_vm.filters.sysName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sysName", $$v)
      },
      expression: "filters.sysName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": "",
      "ResetButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.UserDevopss,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight,
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "运维人员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "员工电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationcompanyName",
      "label": "公司名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysName",
      "label": "系统用户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "certificate",
      "label": "证书有效日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运维证书"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "30px",
            "height": "16px"
          },
          attrs: {
            "src": "/static/query.png",
            "preview-src-list": scope.row.srcList
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), (_vm.usertype == 0) ? _c('table-delete-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.type,
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formUserDevops",
    attrs: {
      "model": _vm.formUserDevops,
      "label-width": "100px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formUserDevops.name),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "name", $$v)
      },
      expression: "formUserDevops.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话号码",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formUserDevops.phone),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "phone", $$v)
      },
      expression: "formUserDevops.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属公司",
      "prop": "operationcompanyId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择所属公司"
    },
    model: {
      value: (_vm.formUserDevops.operationcompanyId),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "operationcompanyId", $$v)
      },
      expression: "formUserDevops.operationcompanyId"
    }
  }, _vm._l((_vm.operationcompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "系统用户",
      "prop": "userid"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择系统用户"
    },
    model: {
      value: (_vm.formUserDevops.userid),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "userid", $$v)
      },
      expression: "formUserDevops.userid"
    }
  }, _vm._l((_vm.systemUserList), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.name,
        "value": item.userId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证书有效期",
      "prop": "certificate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formUserDevops.certificate),
      callback: function($$v) {
        _vm.$set(_vm.formUserDevops, "certificate", $$v)
      },
      expression: "formUserDevops.certificate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证书图片",
      "prop": "picture"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "http-request": _vm.httpRequest,
      "name": "file",
      "on-change": _vm.change,
      "on-remove": _vm.remove,
      "accept": "image/*",
      "file-list": _vm.fileListShow,
      "list-type": "picture",
      "multiple": "",
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，且最好不超过500kb")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-3471eeb1"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/UserDevops.vue
// module id = 1898
// module chunks = 1